import { Image } from '@models/Image'
import { AvailableLocale } from '@models/Lang'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { MEMBERSHIP_DEMO_BOOKLET_URL } from '@utils/urls'

type DemoBooklet = Partial<Record<AvailableLocale, Image | null>>

const fetchDemoBooklet = () =>
  SBAPI.Fetch<DemoBooklet>(MEMBERSHIP_DEMO_BOOKLET_URL)

/**
 * Replace the demo booklet of one or more locales. Locales left out keep the
 * booklet they already have.
 */
const updateDemoBooklet = (files: Partial<Record<AvailableLocale, File>>) => {
  const data = new FormData()
  Object.entries(files).forEach(([locale, file]) => {
    if (file) {
      data.append(`${locale}[file]`, file)
    }
  })
  return SBAPI.Post(MEMBERSHIP_DEMO_BOOKLET_URL, data)
}

export { fetchDemoBooklet, updateDemoBooklet }
export type { DemoBooklet }
